import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";

const UnsavedPopup = ({
  showUnsavedPopup,
  setShowUnsavedPopup,
  hasUnsavedChanges,
  setHasUnsavedChanges,
  handlePopupExit,
}) => {
  return (
    <Dialog open={showUnsavedPopup}>
      <DialogTitle>Unsaved Changes</DialogTitle>
      <DialogContent>
        You have unsaved changes. Are you sure you want to exit?
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            setShowUnsavedPopup(false);
          }}
        >
          Cancel
        </Button>
        <Button variant="contained" onClick={handlePopupExit}>Exit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedPopup;
